<template>
    
    <div class="content">
        404 错误  页面不存在
    </div>
    
</template>
    
<script>
export default {
    data(){
        return{
            
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
